export const classList = (...list: (string | undefined | null)[]) => list.filter((v) => !!v).join(' ');
